/*
 * @Author: etong
 * @Date: 2020-09-17 16:47:30
 * @LastEditTime: 2022-03-18 15:10:37
 * @LastEditors: WangQi
 * @Description:
 * @FilePath: \oak\src\mixins\index.js
 * Think first, Program later
 */
import { debounce } from '@/utils/index'
const mixin = {
  data() {
    return {
      $currentRoutePath: '', // 当前路由的路径
      commonListMarkScrollToTop: 0, // 页面列表滚动距离标记
      _scrollHandler: null // 保存事件处理函数引用
    }
  },
  created() {
    this.$currentRoutePath = this.$route && this.$route.path || ''
  },
  watch: {
    $route(newVal, oldVal) {
      this.setScrollToTop()
    }
  },
  // 进入缓存组件时监听滚动事件
  activated() {
    if (this.$refs.table && this.$refs.table.bodyWrapper) {
      // 创建并保存事件处理函数的引用
      if (!this._scrollHandler) {
        this._scrollHandler = debounce(this.commonListScrollToTop, 500)
      }
      this.$refs.table.bodyWrapper.addEventListener('scroll', this._scrollHandler)
    }
  },
  // 离开缓存组件时移除滚动事件
  deactivated() {
    if (this.$refs.table && this.$refs.table.bodyWrapper && this._scrollHandler) {
      // 使用保存的同一个函数引用移除事件监听
      this.$refs.table.bodyWrapper.removeEventListener('scroll', this._scrollHandler)
    }
  },
  // 组件销毁时清理
  beforeDestroy() {
    if (this.$refs.table && this.$refs.table.bodyWrapper && this._scrollHandler) {
      this.$refs.table.bodyWrapper.removeEventListener('scroll', this._scrollHandler)
      this._scrollHandler = null
    }
  },
  methods: {
    $getMenuChangeToStatus(listLen, pageNo, pageSize, listIndex, total) {
      // 只有一条数据
      let btnPrev = null, btnNext = null
      if (listLen == 1) {
        btnPrev = false
        btnNext = false
      } else if (pageNo == 1 && listIndex == 0) { // 第一页第一条
        btnPrev = false
        btnNext = true
      } else if (pageSize * pageNo >= total && listIndex == listLen - 1) { // 最后一页最后一条
        btnPrev = true
        btnNext = false
      } else {
        btnPrev = true
        btnNext = true
      }
      return [btnPrev, btnNext]
    },
    /**
     * @description: 获取距顶部滚动高度的方法
     * @param {*}
     * @return {*}
     */
    commonListScrollToTop(type) {
      if (this.$refs.table) {
        const scrollTop = this.$refs.table.bodyWrapper.scrollTop // 实时获取el-table组件当前滚动位置，距顶部的滚动高度
        this.commonListMarkScrollToTop = scrollTop // 赋值给 this.scrollTop 用于下次进入时调用
      }
    },
    setScrollToTop() {
      if (this.commonListMarkScrollToTop > 0) {
        setTimeout(() => {
          this.$refs.table.bodyWrapper && this.$refs.table.bodyWrapper.scrollTo(0, this.commonListMarkScrollToTop)
        }, 0)
      }
    }
  }
}
export default mixin
